import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Eyebrow, Reveal } from "./Reveal";
import { content } from "../../data/content";

export const Faq = ({ t, lang }) => (
  <section id="faq" className="bg-[#EFECE6] py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <Reveal>
        <Eyebrow>{t.faq.eyebrow}</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-normal tracking-tight text-[#1E2721] sm:text-4xl lg:text-5xl">
          {t.faq.title}
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {content.faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-accordion-item-${i}`}
              className="border-b border-[#4D6354]/15"
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg text-[#1E2721] transition-colors hover:text-[#4D6354] hover:no-underline sm:text-xl">
                {f[lang].q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-[#4A554D] sm:text-base">
                {f[lang].a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
